
  import { defineComponent } from 'vue';

  const classes = {
    1: 'legacy-heading',
    2: 'legacy-heading text-xl',
    3: 'legacy-heading text-lg',
  };

  interface HeadingProps {
    level?: 1|2|3;
  }

  export default defineComponent<HeadingProps>({
    props: {
      level: {
        default: 1,
      },
    },
    setup(props) {
      return {
        tag: `h${props.level}`,
        headingClass: classes[props.level ?? 1],
      };
    },
  });
